import Vue from "vue";
import VueI18n from "vue-i18n";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from "@/config/const";
import ja from "@/i18n/ja.js";
import en from "@/i18n/en.js";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { ja, en }
});
